export const config = {
    bookingsDataUrl: process.env.REACT_APP_BOOKINGS_DATA_URL
}
